export enum SortLeadsByOptionsEnum {
    NAME = 'name',
    EMAIL = 'email',
    PHONE = 'phone',
    CITY = 'city',
    ZIP_CODE = 'zip_code',
    COUNTY = 'county',
    CATEGORY_LABEL = 'category_label',
    BUYER_NAME = 'buyerName',
    PRICE = 'price',
    SENT_DATE = 'sent_date',
    LABEL = 'label',
    BILLING = 'billing',
    CREATED = 'created',
    STATE = 'state',
    VERIFIED = 'verified',
}